import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeviceService, IconComponent } from '@gains-com/ui-angular';
import { MatIconButton } from '@angular/material/button';
import { SidenavLink } from '../left-sidenav/left-sidenav.component';
import { RouterLink } from '@angular/router';
import { WindowProvider } from '../../core/window.provider';
import { NgClass } from '@angular/common';
import { environment } from '../../../environments/environment';
import { IntercomClient } from '../../core/intercom-client.service.js';
import { UserViewService } from '../../core/view-states/user-view.service.js';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [IconComponent, MatIconButton, RouterLink, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly _window = inject(WindowProvider);
  private readonly _intercom = inject(IntercomClient);
  private readonly _userView = inject(UserViewService);
  readonly device = inject(DeviceService);

  version = environment.version;

  private readonly _user = toSignal(this._userView.state$);

  // Hide the footer "VIP Program" link when the per-user vip kill-switch is
  // explicitly off. null/undefined (never toggled) and true both mean shown —
  // mirrors the left-sidenav nav entry and killSwitchGuard.
  readonly showVipLink = computed(() => this._user()?.vip_enabled !== false);

  readonly socialLinks: SidenavLink[] = [
    { iconKey: 'social:x', link: 'https://x.com/playongains' },
    {
      iconKey: 'social:instagram',
      link: 'https://www.instagram.com/playongains',
    },
    { iconKey: 'social:tiktok', link: 'https://www.tiktok.com/@playongains' },
    { iconKey: 'social:discord', link: 'https://discord.gg/gains' },
    { iconKey: 'social:facebook', link: 'https://www.facebook.com/playongains' },
  ];

  openLink(link: string) {
    this._window.open(link, '_blank');
  }

  openCustomerSupport() {
    this._intercom.open();
  }
}
